import { createSelector } from 'reselect';

import type { RootState } from 'config/store/reducers';

import { getEntity } from 'modules/entity/selectors';

const getState = (state: RootState) => state.customize;

export const getUI = createSelector(getState, (customize) => customize.ui);

const getTemplate = createSelector(getUI, (ui) => ui.template);

export const getUiTranslations = createSelector(getEntity, (template) => template?.translations ?? {});

export const isOpenSaveModal = createSelector(getTemplate, (template) => template.isSaveModalOpen);

export const isEditOpen = createSelector(getTemplate, (template) => template.isEdit);
